import { debounce } from '@opten/reactive/debounce';

export class ScrollbarHelper {
	private root: HTMLElement;

	constructor() {
		this.root = document.documentElement;
		this.setScrollbarWidth();

		document.addEventListener(
			'resize',
			debounce(this.setScrollbarWidth, 500)
		);
		this.observeBody();
	}

	static getScrollbarWidth(): number {
		return window.innerWidth - document.documentElement.clientWidth;
	}

	private setScrollbarWidth(): void {
		this.root.style.setProperty(
			'--scrollbar-width',
			`${ScrollbarHelper.getScrollbarWidth()}px`
		);
	}

	private observeBody(): void {
		const target = document.body;
		const config = { attributes: true, childList: true, subtree: false };

		// Create an observer instance linked to the callback function
		const observer = new MutationObserver((mutationsList, observer) => {
			for (const mutation of mutationsList) {
				if (
					mutation.type === 'attributes' &&
					mutation.attributeName === 'style'
				) {
					this.setScrollbarWidth();
				}
			}
		});

		// Start observing the target node for configured mutations
		observer.observe(target, config);
	}
}
